import { Component } from '@angular/core';
@Component({
    selector: "page-menu",
    templateUrl: "menu.component.html"
})

export class MenuComponent {
    public name = "aqui"
}